import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import { colors, Icons, mediaQueries, size } from '@everlywell/leaves';

import styled from 'styled-components';

export const MainContainer = styled.div`
  ${mediaQueries.forTabletVerticalUp} {
    margin-bottom: ${size.md}px;
  }

  .swiper-container {
    padding-bottom: ${size.xl1}px;

    .swiper-slide {
      min-height: 245px;
      overflow: hidden;
      position: relative;
      justify-content: center;
      display: flex;
      height: 100%;
      width: 100%;

      ${mediaQueries.forTabletVerticalUp} {
        min-height: 349px;
      }
      ${mediaQueries.forDesktopUp} {
        min-height: 513px;
      }

      img {
        padding: 0 ${size.md}px;
      }
    }

    .swiper-pagination {
      &-bullet {
        width: 20px;
        height: 4px;
        border-radius: 4px;
        background-color: ${colors.teal3};

        &-active {
          pointer-events: none;
        }
      }
    }
  }
`;

export const NavigationButton = styled.button`
  background: none;
  display: inline-flex;
  padding: 0 ${size.xs2}px;
  border: none;
  cursor: pointer;
  border-radius: 1px;
  align-items: center;
  height: 35px;
  width: 35px;

  &:focus {
    outline: none;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    border: 1px solid ${colors.teal6};
    padding: 11.4px 13.5px;
    border: 1px solid ${colors.green5};
    border-radius: 1px;
    transition: all 0.15s ease-in-out;

    &:hover {
      background-color: ${colors.teal5};
      border-color: ${colors.teal5};
      & > svg {
        color: ${colors.white};
      }
    }

    &:active {
      background-color: ${colors.teal6};
      border-color: ${colors.teal6};
      & > svg {
        color: ${colors.white};
      }
    }
  }

  &.prev-slide,
  &.next-slide {
    position: absolute;
    top: 40%;
    z-index: 1;

    ${mediaQueries.forTabletHorizontalUp} {
      top: 50%;
    }
  }

  &.next-slide {
    right: 0;
    justify-content: right;
  }
`;

export const LeftIcon = styled(Icons.LeftCaret)`
  color: ${colors.teal6};
  display: block;
  width: 15px;
  height: 20px;
`;

export const RightIcon = styled(Icons.RightCaret)`
  color: ${colors.teal6};
  display: block;
  width: 15px;
  height: 20px;
`;
